import '../question_per_page_input';
import '../question_sort_input';
import './index.scss';
import 'components/select';
import { Application, Controller } from 'utils/stimulus';

const FONT_SIZES = ['small', 'medium', 'large', 'extra-large'];

class QuestionsToolsController extends Controller {
  static targets = ['viewMode'];

  state = {
    fontSize: 'medium'
  };

  initialize() {
    this.whatsNew();

    if (!this.isPageAllowed()) {
      $('html').removeAttr('data-view-mode');
    }

    if (this.data.get('playgroundPrint') === 'true') {
      this.print({
        currentTarget: { dataset: { printUrl: this.data.get('printUrl') } }
      });
    }

    window.addEventListener('turbolinks:before-render', () => {
      if (!this.isPageAllowed()) {
        this.restoreDefaultTheme();
      }
    });

    if (this.data.get('limitReached') === 'true') {
      const context = $('.q-route-questions-index');
      $('.q-root', context).addClass('q-print-page-not-allowed');
    }
  }

  whatsNew() {
    const whatsNewView = localStorage.getItem('whatsNewView');
    const statisticsButton = $('#filter-statistics-button');
    const pulseCta = $('.cta-pulse.cta-pulse-blue', statisticsButton);

    if (pulseCta.length && whatsNewView === 'true') {
      pulseCta.remove();
    }

    if (pulseCta.length && statisticsButton.length) {
      statisticsButton.on('click', () => {
        pulseCta.remove();
        localStorage.setItem('whatsNewView', true);
      });
    }
  }

  connect() {
    if (this.hasViewModeTarget) {
      this.$viewModeSelect = $(this.viewModeTarget);
      this.$viewModeSelect.qselect(
        'on',
        'change',
        this.changeViewMode.bind(this)
      );
    }

    this.loadState();
  }

  isPageAllowed() {
    const pathname = window.location.pathname;
    const parts = window.location.pathname.split('/');
    return (
      $('body').data('is-user-signed-in') &&
      parts.pop() === 'questoes' &&
      pathname.indexOf('/usuario/') < 0
    );
  }

  loadState() {
    if (!window.localStorage || !this.isPageAllowed()) {
      return;
    }

    const stateJSON = window.localStorage.getItem('questionSubFilterFormState');

    if (stateJSON) {
      this.state = JSON.parse(stateJSON);
      delete this.state.viewMode;
    }
    const { fontSize } = this.state;

    if (fontSize) {
      this.applyFontSize(fontSize);
    }

    if (this.$viewModeSelect) {
      this.$viewModeSelect.qselect('default');
    }
  }

  setState(option, value, inMemory = false) {
    this.state[option] = value;

    if (!inMemory) {
      this.saveState(inMemory);
    }
  }

  getState(option) {
    return this.state[option];
  }

  saveState() {
    if (window.localStorage) {
      window.localStorage.setItem(
        'questionSubFilterFormState',
        JSON.stringify(this.state)
      );
    }
  }

  applyFontSize(fontSize) {
    this.$questionListElement =
      this.$questionListElement || $('.js-questions-list').get(0);
    this.$questionListElement.dataset.fontSize = fontSize;
  }

  applyViewMode(mode) {
    document.documentElement.dataset.viewMode = mode;
  }

  changeViewMode(e) {
    const mode = e instanceof Event ? e.currentTarget.dataset.mode : e;
    this.applyViewMode(mode);
    this.setState('viewMode', mode, false);
  }

  toggleNightMode() {
    const currentViewMode = this.getState('viewMode');
    this.changeViewMode(currentViewMode === 'night' ? 'default' : 'night');
  }

  restoreDefaultTheme() {
    const currentViewMode = this.getState('viewMode');

    if (currentViewMode !== 'default') {
      this.changeViewMode('default');
    }
  }

  changeFontSize(e) {
    const { actionType } = e.currentTarget.dataset;
    const current = this.getState('fontSize') || 'medium';
    const currentIndex = FONT_SIZES.indexOf(current);
    const targetIndex =
      actionType === 'increase' ? currentIndex + 1 : currentIndex - 1;
    const target = FONT_SIZES[targetIndex];

    if (targetIndex <= -1 || !target) {
      return;
    }

    this.applyFontSize(target);
    this.setState('fontSize', target);
  }

  print(e) {
    const currentViewMode = this.getState('viewMode');
    this.applyViewMode('default');
    const { printUrl } = e.currentTarget.dataset;
    window.print();
    this.applyViewMode(currentViewMode);

    // FIXME: Temporary solution to force page reload to count print limit for not subscribed users.
    Turbolinks.visit(printUrl);
  }
}

window.QuestionToolsApplication =
  window.QuestionToolsApplication || Application.start();
window.QuestionToolsApplication.register(
  'questions-tools',
  QuestionsToolsController
);
